<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" md="4">
          <div class="sticky-md" style="top: 110px">
            <qr-maker />
            <v-card-actions class="justify-center">
              <div class="rowinfo">
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-showdownload`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                  style="
                    padding: unset !important;
                    align-self: center !important;
                  "
                />
              </div>
            </v-card-actions>
          </div>
        </v-col>

        <v-col class="pa-8" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>ورود اطلاعات</p>
                  <div v-if="e6 === 1">
                    <v-switch v-model="qrType" disabled>
                      <template v-slot:label>
                        <span class="text-muted"> کیوآر داینامیک باشد</span>
                        <p class="text-danger ml-2 mb-0">به زودی</p>
                      </template>
                    </v-switch>
                  </div>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام کیوآر"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام کیوآر"
                    />
                  </div>
                </div>
                <div v-if="qrType" class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <qr-address-field
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      append-icon="mdi-web"
                      class="mt-0 pt-0 contentinfo"
                      dense
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"
                      persistent-hint
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dtUrl`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="آدرس پیشفرض"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion icon="at" single title="ایمیل">
                <template v-slot:content>
                  <v-row no-gutters>
                    <v-col class="pa-2" cols="12" md="6">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="data.email"
                          :rules="urlRules"
                          append-icon="mdi-at"
                          counter="50"
                          dense
                          hint="example@any.com"
                          label="ایمیل"
                          maxLength="50"
                          outlined
                          placeholder="ایمیل موردنظر خودرا وارد کنید."
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-email`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="ایمیل"
                        />
                      </div>
                    </v-col>
                    <v-col class="pa-2" cols="12" md="6">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="data.subject"
                          class="contentinfo"
                          dense
                          label="عنوان"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-subject`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="عنوان"
                        />
                      </div>
                    </v-col>
                    <v-col class="pa-2" cols="12">
                      <div class="rowinfo">
                        <v-textarea
                          v-model="data.message"
                          dense
                          label="متن پیام"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-message`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="متن پیام"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </list-expansion>

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6 = 2"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step
              v-if="qrType"
              :complete="e6 > 2"
              class="px-0 px-md-4"
              step="2"
              >تنظیمات کیوآر</v-stepper-step
            >
            <v-stepper-content
              v-if="qrType"
              class="pr-1 mx-0 mr-md-7 px-md-4"
              step="2"
            >
              <qr-management :data="data" />
              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 1" />
                </div>

                <div class="col-md-6">
                  <!--              <next-btn :loading="loading" @click="setSettings"/>-->
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-step
              :complete="qrType ? e6 > 3 : e6 > 2"
              :step="qrType ? 3 : 2"
              class="px-0 px-md-4"
            >
              دیزاین کیوآر
            </v-stepper-step>
            <v-stepper-content
              :step="qrType ? 3 : 2"
              class="pr-1 mx-0 mr-md-7 px-md-4"
            >
              <!--          <qr-customize v-model="qrDesign"/>-->
              <qr-code-make
                ref="qrCanvas"
                v-model="qrDesign"
                :file.sync="qrSvgDataUrl"
                :link="data.link"
                @save="qrDesign = $event"
              />
              <div class="row mx-auto">
                <!--            <div class="col-md-6">-->
                <!--              <prev-btn :loading="loading" text="ویرایش" style="background: orange"-->
                <!--                        @click="goto(`qr/${createdId}/edit`)" v-if="finish"/>-->

                <!--&lt;!&ndash;              <prev-btn :loading="loading" @click="e6 = 2" v-else/>&ndash;&gt;-->
                <!--            </div>-->

                <div class="col-md-12">
                  <div class="rowinfo" style="width: 100%" v-if="data.svg">
                    <v-btn
                      class="btn-download float-left"
                      @click="showDialog = true"
                    >
                      <v-icon>mdi-progress-download</v-icon>
                      {{ $t("download_qr") }}                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-data-svg`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label=" دانلود کیوآر"
                      style="padding: unset !important"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: 'دانلود کیوآر' }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-download_Qr-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>

          <v-card class="px-5">
            <download-file
              v-if="showDialog"
              :address="`${data.domain.name||'qrland.in/'}${data.identifier}`"
              :visit-name="visitName"
              @close="showDialog = false"
              :qr_id="info.qrId"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrCodeMake from "./qrCodeStyle/qrCodeMake.vue";
import QrMaker from "./components/qrMaker.vue";
import QrManagement from "./components/qrManage/qrManagement.vue";
import ListExpansion from "../../content/fragments/listExpansion.vue";
import NextBtn from "../../content/fragments/nextBtn.vue";
import PrevBtn from "../../content/fragments/prevBtn.vue";
import QrAddressField from "../../content/fragments/qrAddressField.vue";
import { debounce } from "../../../main";
import DownloadFileWithApi from "./downloadFileWithApi.vue";

export default {
  name: "qrMail",

  components: {
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    QrMaker,
    QrCodeMake,
    DownloadFileWithApi,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "qrMail",
      qrSvgDataUrl: "",
      qrType: false,
      showDialog: false,
      editable: false,
      createdId: "",
      loading: false,
      finish: false,
      dtUrl: null,
      e6: 1,
      visitName: "ایمیل",
      urlRules: [(value) => this.isEmail(value) || "ایمیل صحیح وارد نمایید. "],
      data: {
        email: "example@any.com",
        subject: "",
        message: "",
      },
      cons: { title: "دانلود کیوآر" },
      qrDesign: null,
    };
  },

  mounted() {
    this.updateQr();
  },

  watch: {
    "data.email"(val) {
      debounce(() => {
        if (!!this.isEmail(val)) this.updateQr();
      }, 500);
    },
  },

  methods: {
    updateQr() {
      setTimeout(() => {
        this.$refs.qrCanvas.appendCanvas(this.data.email);
      }, 500);
    },
    isEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
  },
};
</script>

<style scoped></style>
